import AbstractOperatorApplicationListener
    from "~/operatorApplication/ts/service/comet/AbstractOperatorApplicationListener";
import OperatorParamsLoader from "~/operatorApplication/ts/service/OperatorParamsLoader";

export default class UpdateParams extends AbstractOperatorApplicationListener {
    public getAction(): string {
        return "updateParams";
    }

    public receive(payload: CometOperatorApplication.UpdateParamsCometMessageOpenApiModel): void {
        OperatorParamsLoader.reload(null, "comet message " + JSON.stringify(payload));
    }

}